import { createFileRoute } from '@tanstack/react-router';
import { assertPublicToolsEnabled } from '@/lib/public-tools-feature';
import {
  getKeywordToolPage,
  KeywordToolSeoPage,
} from '@/components/astro/new-design-25/SEO/keyword-tool-pages';
import { normalizeCanonicalUrl } from '@/seo/canonical';
import { seo } from '@/seo/seo';

const page = getKeywordToolPage('academic-paper-reader');
if (!page) throw new Error('Missing keyword SEO page: academic-paper-reader');

export const Route = createFileRoute('/_marketing/_seo/academic-paper-reader')({
  beforeLoad: assertPublicToolsEnabled,
  head: () => ({
    meta: [
      ...seo({
        title: page.metaTitle,
        description: page.metaDescription,
      }),
    ],
    links: [
      {
        rel: 'canonical',
        href: normalizeCanonicalUrl('/academic-paper-reader'),
      },
    ],
  }),
  component: () => <KeywordToolSeoPage page={page} />,
});
